var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"279c900045a681c26d3913dada37070a4e840004"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cube-front@rac"]={id:"279c900045a681c26d3913dada37070a4e840004"};
      